export default "__VITE_ASSET__ClSMSbPV__"